import { useEffect, useState } from "react";
import { getTimeLeftProposal } from "../../../../../utils/format-date-time-message.utils";
import ProposalCountDown from "./proposal/proposal-count-down";

interface Props {
    expiryDate: string;
}

export default function ProposalCountDownContainer({ expiryDate, }: Props) {
    const [timeLeft, setTimeLeft] = useState(() =>
        getTimeLeftProposal(expiryDate)
    );

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getTimeLeftProposal(expiryDate));
        }, 1000);

        return () => clearInterval(interval);
    }, [expiryDate]);

    return (
        <ProposalCountDown
            isExpired={timeLeft.expired}
            timeLeft={timeLeft}
        />
    );
}